import React, { useState, useEffect, createRef } from 'react';
import { Link } from 'react-router-dom';
import CardContainer from '../../components/card/card-container.jsx';
import LabelNumber from '../../components/label/label-number.jsx';
import Api from '../../api/global.service';
import { useAuth } from '../../components/content/auth.jsx';
import env from '../../environment.js';
import NoPagination from '../../components/pagination/noPagination.jsx';
import SelectCiclo from '../../components/select/select-ciclo.jsx';
import LinkDownload from '../../components/link/link-download.jsx';
import { useHistory } from 'react-router-dom';
import { useCoopConfig } from '../../components/content/coop-config.jsx';
import SearchColumn from '../../components/search/search-column.jsx';
import ListToolbar, { BtnNuevo } from '../../nuup/componentes/Toolbar/ListToolbar.jsx';
import CalidadListExport from './components/calidad-list-export.js';
import { calcRendimientoBruto, calcRendimientoExportable, calcManchaPorcentaje, calcDefectosManchaPor, calcTotalDefectosRedondeado } from './components/calidad-calculos.js';
import getBackgroundColor from '../../utils/getBackgroundColor.js';
import getColor from '../../utils/getColor.js';

const CalidadList = () => {
  const history = useHistory();
  const auth = useAuth();
  const coopConfig = useCoopConfig();
  const [data, setData] = useState([]);
  const [originalData, setOriginalData] = useState([]);
  const [ciclo, setCiclo] = useState({});
  const [blocking, setBlocking] = useState(false);
  const [btnLotes, setBtnLotes] = useState(true);
  const [idsSeleccionados, setIdsSeleccionados] = useState([]);

  const columns = React.useMemo(
    () => [
      {
        Header: 'INFORMACIÓN GENERAL DE LA MUESTRA',
        columns: [
          {
            Header: 'FOLIO',
            // Usar id_muestra si se registró en el formulario, si no , usar folio que se genera automáticamente
            accessor: (row) => row?.info_muestra?.id_muestra ?? row?.info_muestra?.folio ?? '',
            sortable: true,
            minWidth: 50,
            Cell: ({ value, row }) => {
              const uuidAnalisis = row?.original?.info_muestra?.uuid_calidad_analisis;
              return (
                <>
                  <span onClick={() => nuevoAnalisis(row.original)} style={{ marginRight: 10, color: '#999' }}>
                    <i className="fa fa-pen"></i>
                  </span>
                  <span>
                    {uuidAnalisis ? (
                      <Link style={{ color: '#86895d' }} to={`/admin/calidad/analisis/visualizacion/${uuidAnalisis}`}>{value}</Link>
                    ) : (
                      <span style={{ color: '#999' }}>{value}</span>
                    )}
                  </span>
                </>
              );
            },
          },
                    {
            Header: 'REPORTE',
            accessor: (row) => row?.info_muestra?.uuid_calidad_analisis ?? '',
            sortable: false,
            minWidth: 60,
            Cell: ({ row }) => {
              const uuidAnalisis = row?.original?.info_muestra?.uuid_calidad_analisis;
              if (!uuidAnalisis) {
                return <span style={{ color: '#999' }}>-</span>;
              }
              return (
                <LinkDownload
                  url={`calidad/analisis/recibo/descargar/${uuidAnalisis}`}
                  label={'PDF'}
                  icon={env.images.icon.pdf}
                />
              );
            },
          },
          {
            Header: 'FECHA',
            accessor: (row) => row?.info_muestra?.fecha ?? '',
            sortable: true,
            minWidth: 50,
          },
          {
            Header: 'NIVEL',
            accessor: (row) => row?.info_muestra?.tipo_analisis ?? '',
            sortable: true,
            minWidth: 50,
          },
                    {
            Header: 'TIPO',
            accessor: (row) => row?.info_muestra?.nombre_tipo_muestra ?? '',
            sortable: true,
            minWidth: 50,
          },
          {
            Header: 'NOMBRE',
            accessor: (row) => row?.info_muestra?.nombre ?? '',
            sortable: true,
            minWidth: 75,
            Cell: ({ value, row }) => {
              return <span>{value}</span>;
            },
          },
          {
            Header: 'ID ENTREGA/ LOTE',
            // Si el tipo de analisis es por productor-entrega (id_lote id_tipo_analisis = 1)
            // Si es tipo de analisis es  por lote (id_lote id_tipo_analisis = 2)
              accessor: (row) => {
                if (Number(row?.info_muestra?.id_tipo_analisis) === 1 || Number(row?.info_muestra?.id_tipo_analisis) === 2) {
                  return row?.info_muestra?.detalle ?? '';
                }
                return '-';
            },
         
            sortable: true,
            minWidth: 50,
          },
          {
            Header: 'REGIÓN',
            accessor: (row) => row?.info_muestra?.region ?? '',
            sortable: true,
            minWidth: 50,
          },
          {
            Header: 'MUNICIPIO',
            accessor: (row) => row?.info_muestra?.nombre_municipio ?? '',
            sortable: true,
            minWidth: 50,
          },
          {
            Header: 'LOCALIDAD',
            accessor: (row) => row?.info_muestra?.nombre_localidad ?? '',
            sortable: true,
            minWidth: 50,
          },
        ],
      },
      {
        Header: 'RESUMEN DE ANÁLISIS',
        columns: [
          {
            Header: 'PROCESO',
            accessor: (row) => row?.info_muestra?.nombre_tipo_proceso ?? '',
            sortable: true,
            maxWidth: 100,
            Cell: ({ value }) => {
              return <p style={{ overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis', maxWidth: 150 }}>{value}</p>;
            },
          },
          {
            id: 'ra_rendimiento_bruto',
            Header: 'RENDIMIENTO BRUTO',
            accessor: (row) => {
              const pm = Number(row?.analisis_fisico?.pergamino_peso_muestra_pergamino ?? 0);
              const po = Number(row?.analisis_fisico?.pergamino_peso_muestra_oro ?? 0);
              return calcRendimientoBruto(pm, po);
            },
            sortable: true,
            minWidth: 50,
            Cell: ({ value }) => {
              return <LabelNumber value={value} digits={2} suffix={'%'}></LabelNumber>;
            },
          },
          { // ontener el valor directo de la base de datos
            id: 're_rendimiento_exportable',
            Header: 'RENDIMIENTO EXPORTABLE',
            accessor: (row) => row?.info_muestra?.rendimiento_exportable_por ?? null,
            sortable: true,
            minWidth: 50,
            Cell: ({ value }) => {
              return <LabelNumber value={value} digits={2} suffix={'%'}></LabelNumber>;
            },
          },
          {
            Header: 'PUNTAJE TAZA',
            accessor: (row) => row?.analisis_sensorial?.puntaje_manual ?? '',
            sortable: true,
            maxWidth: 100,
            Cell: ({ value }) => {
              return <p style={{ overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis', maxWidth: 150 }}>{value}</p>;
            },
          },
          {
            Header: 'OBSERVACIONES',
            accessor: (row) => row?.info_muestra?.observaciones ?? '',
            sortable: true,
            maxWidth: 100,
            Cell: ({ value }) => {
              return <p style={{ overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis', maxWidth: 150 }}>{value}</p>;
            },
          },
        ],
      },
      {
        Header: 'ANÁLISIS FÍSICO',
        columns: [
          {
            Header: 'PESO DE LA MUESTRA',
            accessor: (row) => row?.analisis_fisico?.pergamino_peso_muestra_pergamino ?? '',
            sortable: true,
            minWidth: 50,
          },
          {
            Header: 'PESO ORO',
            accessor: (row) => row?.analisis_fisico?.pergamino_peso_muestra_oro ?? '',
            sortable: true,
            minWidth: 50,
          },
          {
            // Rendimiento bruto (= Peso en Oro / Peso de la muestra * 100) redondeado 2 decimales
            id: 'af_rendimiento_bruto',
            Header: 'RENDIMIENTO BRUTO',
            accessor: (row) => {
              const pm = Number(row?.analisis_fisico?.pergamino_peso_muestra_pergamino ?? 0);
              const po = Number(row?.analisis_fisico?.pergamino_peso_muestra_oro ?? 0);
              return calcRendimientoBruto(pm, po);
            },
            sortable: true,
            minWidth: 50,
            Cell: ({ value }) => {
              return <LabelNumber value={value} digits={2} suffix={'%'}></LabelNumber>;
            },
          },
          {
            Header: 'HUMEDAD',
            accessor: (row) => row?.analisis_fisico?.pergamino_humedad ?? '',
            sortable: true,
            minWidth: 50,
            Cell: ({ value }) => {
              return <LabelNumber value={value} digits={2} suffix={'%'}></LabelNumber>;
            },
          },
          {
            // Mancha (%) (= Mancha (gr.) / Peso de la muestra * 100) redondeado 2 decimales
            id: 'af_mancha',
            Header: 'MANCHA',
            accessor: (row) => {
              const pm = Number(row?.analisis_fisico?.pergamino_peso_muestra_pergamino ?? 0);
              const df = Number(row?.analisis_fisico?.pergamino_peso_mancha ?? 0);
              return calcManchaPorcentaje(pm, df);
            },
            sortable: true,
            minWidth: 50,
            Cell: ({ value }) => {
              return <LabelNumber value={value} digits={2} suffix={' %'}></LabelNumber>;
            },
          },
          {
            Header: 'DENSIDAD (g./l.)',
            accessor: (row) => row?.analisis_fisico?.pergamino_densidad ?? '',
            sortable: true,
            minWidth: 50,
          },
          {
            Header: 'ACTIVIDAD EN AGUA',
            accessor: (row) => row?.analisis_fisico?.pergamino_actividad_agua ?? '',
            sortable: true,
            minWidth: 50,
          },
          {
            Header: 'AROMA / OLOR',
            accessor: (row) => row?.analisis_fisico?.olor_muestra ?? '',
            sortable: true,
            minWidth: 50,
          },
        ]
      },
      {
        Header: 'ANÁLISIS ORO',
        columns: [
          {
            id: 'ao_criba_zarandas',
            Header: 'CRIBA / ZARANDA',
            accessor: (row) => row?.analisis_oro?.zarandas?.map((item) => item?.nombre_zaranda ?? '').join(', ') ?? '',
            sortable: true,
            minWidth: 50,
          },
          { // Nombre de los defectos primarios y secundarios
            id: 'ao_defectos',
            Header: 'DEFECTOS',
            accessor: (row) => {
              const prim = row?.analisis_oro?.defectos_primarios?.map((item) => item?.nombre_mancha ?? '').join(', ') ?? '';
              const sec = row?.analisis_oro?.defectos_secundarios?.map((item) => item?.nombre_mancha ?? '').join(', ') ?? '';
              return prim + (sec !== '' ? ' / ' + sec : '');
            },
            sortable: true,
            minWidth: 75,
          },
          {
            id: 'ao_total_defectos',
            Header: 'TOTAL DEFECTOS',
            accessor: (row) => {
              const prim = Array.isArray(row?.analisis_oro?.defectos_primarios) ? row.analisis_oro.defectos_primarios : [];
              const sec = Array.isArray(row?.analisis_oro?.defectos_secundarios) ? row.analisis_oro.defectos_secundarios : [];
              const total = calcTotalDefectosRedondeado(prim, sec);
              return total > 0 ? `${total}` : '';
            },
            sortable: true,
            minWidth: 75,
          },
                    {
            id: 'ao_defectos_mancha',
            Header: 'DEFECTOS (%) ', // Gramos total de mancha (total_defectos_gramos) / Peso en Oro (pergamino_peso_muestra_oro_2) * 100)
            accessor: (row) => {
              const po = Number(row?.analisis_oro?.pergamino_peso_muestra_oro_2 ?? 0);
              const df = Number(row?.analisis_oro?.total_defectos_gramos ?? 0);
              return calcDefectosManchaPor(po, df);
            },
            sortable: true,
            minWidth: 50,
            Cell: ({ value, row }) => {
              if (value !== '' && value != null) {
                return value + ' %';
              }
              return '-';
            },
          },
          {
            id: 'ao_cafe_limpio',
            Header: 'CAFE LIMPIO (grs.)',
            accessor: (row) => row?.info_muestra?.peso_cafe_limpio_grs > 0 ? row?.info_muestra?.peso_cafe_limpio_grs : null,
            sortable: true,
            minWidth: 50,
            Cell: ({ value }) => {
              return <LabelNumber value={value} digits={2}></LabelNumber>;
            },
          },
          { // ontener el valor directo de la base de datos
            id: 'ao_rendimiento_exportable',
            Header: 'RENDIMIENTO EXPORTABLE',
            accessor: (row) => row?.info_muestra?.rendimiento_exportable_por ?? null,
            sortable: true,
            minWidth: 50,
            Cell: ({ value }) => {
              return <LabelNumber value={value} digits={2} suffix={'%'}></LabelNumber>;
            },
          },
          {
            Header: 'RENDIMIENTO REAL',
            accessor: (row) => {
  
              const re = Number(row?.info_muestra?.rendimiento_exportable_por ?? 0);
              const dp = Number(row?.info_muestra?.perdida_procesamiento_por ?? 0);
              
              if (re > 0 && dp >= 0) {
                return (re - dp).toFixed(2) + ' %';
              }
              
              return '';
            },
            sortable: true,
            minWidth: 50,
            Cell: ({ value, row }) => {
              if (value !== '' && value != null) {
                return value;
              }
              return '-';
            },
          },
        ],
      },
      {
        Header: 'ANÁLISIS SENSORIAL',
        columns: [
          {
            id: 'as_perfil_taza',
            Header: 'PERFIL EN TAZA',
            accessor: (row) => row?.analisis_sensorial?.perfil_taza ?? '',
            sortable: true,
            maxWidth: 100,
            Cell: ({ value, row }) => {
              return <p style={{ overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis', maxWidth: 150 }}>{value}</p>;
            },
          },
          {
            id: 'as_puntaje_taza',
            Header: 'PUNTAJE EN TAZA',
            accessor: (row) => row?.analisis_sensorial?.puntaje_manual ?? '',
            sortable: true,
            minWidth: 75,
          },
        ],
      },
    ],
    [idsSeleccionados, btnLotes]
  );

  const searchColumns = React.useMemo(
    () => [
      { value: 0, target: '', label: 'TODO' },
      { value: 1, target: '_folio', label: 'FOLIO' },
      { value: 2, target: '_fecha', label: 'FECHA' },
      { value: 3, target: '_nivel', label: 'NIVEL' },
      { value: 4, target: '_tipo', label: 'TIPO' },
      { value: 5, target: '_nombre', label: 'NOMBRE' },
      { value: 6, target: '_entrega_lote', label: 'ID ENTREGA/LOTE' },
      { value: 7, target: '_region', label: 'REGIÓN' },
      { value: 8, target: '_municipio', label: 'MUNICIPIO' },
      { value: 9, target: '_localidad', label: 'LOCALIDAD' },
    ],
    []
  );

  const setFilter = value => {
    setCiclo(value.target);
  };

  const setDataFilter = data => {
    setData(data);
  };

  const getData = () => {
    // Ahora enviamos el id del ciclo seleccionado
    Api.getAll('calidad/analisis', { id_ciclo: ciclo.id }) 
      .then(response => {
        setBlocking(false);
        if (typeof response.data !== 'undefined') {
          const processedData = response.data.map(item => ({
            ...item,
            _folio: item?.info_muestra?.id_muestra ?? item?.info_muestra?.folio ?? '',
            _nombre: item?.info_muestra?.nombre ?? '',
            _municipio: item?.info_muestra?.nombre_municipio ?? '',
            _region: item?.info_muestra?.region ?? '',
            _localidad: item?.info_muestra?.nombre_localidad ?? '',
            _entrega_lote: item?.info_muestra?.id_acopio ?? item?.info_muestra?.id_recoleccion_acopio ?? '',
            _fecha: item?.info_muestra?.fecha ?? '',
            _nivel: item?.info_muestra?.tipo_analisis ?? '',
            _tipo: item?.info_muestra?.nombre_tipo_muestra ?? ''
          }));
          setData(processedData);
          setOriginalData(processedData);
        }
        setBlocking(false);
      })
      .catch(e => {
        console.log('e', e);
        setBlocking(false);
      });
  };

  useEffect(() => {
    getData();
  }, [ciclo]);

  const nuevoAnalisis = (data = {}) => {
    let defaultConfig = {
      info_muestra: {},
      analisis_fisico: {},
      analisis_oro: {},
      analisis_sensorial: {},
    };

    if (typeof data?.info_muestra !== 'undefined') {
      defaultConfig = data;
    }

    localStorage.setItem(`${env.appName}-calidad`, JSON.stringify(defaultConfig));
    history.push({
      pathname: '/admin/calidad/seleccion',
    });
  };

  return (
    <div>

        <div className="row">
          <div className="col-10">
              <SelectCiclo  
                setFilter={setFilter}
                ciclo={ciclo}
              />
          </div>
          <div className="col-2">
            <div style={{ display: 'flex', justifyContent: 'flex-end',paddingRight: 10 }}>
              {data.length > 0 && (
                <Link to="#" onClick={() => CalidadListExport(data)} className="m-r-2" style={{ color: '#789D16' }}>
                  <img src={env.images.icon.xls} className="pr-1" /> <span>Descargar Excel</span>
                </Link>
              )}
            </div>
          </div>
        </div>

      <CardContainer height={'100%'} style={{ marginTop: 10 }}>


        <ListToolbar left={<SearchColumn data={originalData} columns={searchColumns} setDataFilter={evt => setDataFilter(evt)} />}>
          <BtnNuevo onClick={() => nuevoAnalisis()}>Registrar nuevo análisis</BtnNuevo>
        </ListToolbar>

        <div className="div-nombre-lote"> {'Útimos registros de muestras'}</div>
        <NoPagination
          blocking={blocking}
          selected="id"
          columns={columns}
          data={data}
          fnBackgroundColor={getBackgroundColor}
          fnColor={getColor}></NoPagination>

      </CardContainer>
    </div>
  );
};

export default CalidadList;
